export default __webpack_public_path__ + "static/media/G0750.34I-27930_-17319_0.1666265220000.a8a3b6e4.jpg";